import { Component } from '@verndale/core';
import Pristine from 'pristinejs';
import serialize from 'form-serialize';
import MicroModal from 'micromodal';
import axios from 'axios';

import {
  PRISTINE_SETTINGS,
  SERIALIZE_SETTINGS
} from '../utils/default-settings';
import { constEvent } from '../utils/constants';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $el: this.el,
      $form: this.el._$('.modal-login-prompt__form'),
      $errorMessage: this.el._$('.modal-login-prompt__error-message'),
      $btnSubmit: this.el._$('.modal-login-prompt__form button[type="submit"]'),
      $openModalTrigger: _$$('[data-open-login-modal]'),
      $promptMessage: _$('.modal-login-prompt__message')
    };
    this.modalId = null;
    this.pristineForm = null;
    this.endpoint = this.dom.$form.getAttribute('action') || null;

    this.init();
    this.pristineInit();
  } //setupDefaults

  addListeners() {
    const { $form, $openModalTrigger } = this.dom;

    $form?._on('input', this.enableDisableBtnSubmit.bind(this));
    $form?._on('submit', this.submitForm.bind(this));
    $openModalTrigger?._on('click', this.showModal.bind(this));
    document._on(constEvent.SHOW_MODAL_LOGIN, this.showModal.bind(this));
  } //addListeners

  init() {
    const { $el } = this.dom;

    const $genericModal = $el.closest('.generic-modal');
    if ($genericModal) {
      this.modalId = $genericModal.getAttribute('id') || null;
    }
  } //init

  pristineInit() {
    const { $form } = this.dom;

    if ($form) {
      this.pristineForm = new Pristine($form, PRISTINE_SETTINGS);
    }
  } //pristineInit

  submitForm(e) {
    e.preventDefault();
    const { $form, $btnSubmit, $errorMessage } = this.dom;
    const formData = serialize($form, SERIALIZE_SETTINGS);
    const valid = this.pristineForm.validate();

    if (valid) {
      $btnSubmit.disabled = true;
      $errorMessage.style.display = 'none';

      axios({
        method: 'post',
        url: this.endpoint,
        data: formData,
        headers: {
          'content-type': 'application/json'
        }
      })
        .then(response => {
          const { success, body, message } = response?.data;

          if (success) {
            const { loginRedirect } = body || {};
            MicroModal.close(this.modalId);

            if (loginRedirect) {
              window.location.href = loginRedirect;
            } else {
              location.reload();
            }
          } else {
            $errorMessage.textContent = message;
            $errorMessage.style.display = 'block';
          }
        })
        .finally(() => {
          $btnSubmit.disabled = false;
        });
    }
  } //submitForm

  enableDisableBtnSubmit() {
    const { $btnSubmit } = this.dom;

    try {
      const valid = this.pristineForm.validate(true);
      $btnSubmit.disabled = !valid;
    } catch (error) {
      return;
    }
  } //enableDisableBtnSubmit

  showModal(e) {
    e.preventDefault();

    if (this.modalId) {
      this.updatePromptMessage(e);

      MicroModal.show(this.modalId, {
        closeTrigger: 'data-generic-modal-close',
        openClass: 'generic-modal--open',
        disableScroll: true,
        disableFocus: true,
        awaitOpenAnimation: true,
        awaitCloseAnimation: true,
        onClose: modal => {
          this.resetModalForm();
        }
      });
    }
  } //showModal

  resetModalForm() {
    const { $errorMessage, $form, $btnSubmit } = this.dom;

    try {
      $errorMessage.style.display = 'none';
      $btnSubmit.disabled = true;
      $form.reset();
      this.pristineForm.reset();
    } catch (error) {
      return;
    }
  } //resetModalForm

  updatePromptMessage(e) {
    const { $promptMessage } = this.dom;
    const type = e?.type;
    let promptMessage = null;

    try {
      if (type === constEvent.SHOW_MODAL_LOGIN) {
        promptMessage = e?.detail || null;
      } else {
        promptMessage = e?.target?.getAttribute('data-prompt-message') || null;
      }

      if (typeof promptMessage !== 'string') {
        promptMessage = '';
      }

      $promptMessage.textContent = promptMessage;
    } catch (error) {
      return;
    }
  } //updatePromptMessage
}

export default Module;
